/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityFindingsAggResult } from './ControlEntityFindingsAggResult';
import {
    ControlEntityFindingsAggResultFromJSON,
    ControlEntityFindingsAggResultFromJSONTyped,
    ControlEntityFindingsAggResultToJSON,
} from './ControlEntityFindingsAggResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityFindingsAggResponse
 */
export interface ControlPaginatedEntityFindingsAggResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsAggResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsAggResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsAggResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityFindingsAggResult>}
     * @memberof ControlPaginatedEntityFindingsAggResponse
     */
    results?: Array<ControlEntityFindingsAggResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityFindingsAggResponse interface.
 */
export function instanceOfControlPaginatedEntityFindingsAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedEntityFindingsAggResponseFromJSON(json: any): ControlPaginatedEntityFindingsAggResponse {
    return ControlPaginatedEntityFindingsAggResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityFindingsAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityFindingsAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityFindingsAggResultFromJSON)),
    };
}

export function ControlPaginatedEntityFindingsAggResponseToJSON(value?: ControlPaginatedEntityFindingsAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityFindingsAggResultToJSON)),
    };
}

